import { Validator } from 'vee-validate'
export default () => {
    const message = {
        custom: {
            fullName: {
                required: (val) => `Enter full name of the recipient`,
            },
            company: {
                required: (val) => `Enter company name for shipping`,
            },
            phone: {
                required: (val) => `Enter phone for shipping address`,
                regex: (val) => `Invalid phone format.`
            },
            line1: {
                required: (val) => `Enter shipping address`
            },
            companyVAT: {
                required: (val) => `Enter company VAT`
            },
            city: {
                required: (val) => `Enter city`
            },
            postalCode: {
                required: (val) => `Enter postal code`,
                regex: (val) => `Invalid sender's post code format. Correct format: ${val}`
            },
            countries: {
                required: (val) => `Enter country`
            },
            state: {
                required: (val) => `Enter state`
            }
        }
    }
    Validator.localize('en', message)
}



// WEBPACK FOOTER //
// ./src/components/UserPanel/Forms/validators.js